import React from 'react';
import { FooterSocialMediaBar } from '../../../components/FooterSocialMediaBar';
import type { LandingCopy } from '../types';

interface Props {
  footer: LandingCopy['footer'];
  locale: LandingCopy['locale'];
  jobsHref: string;
}

export function LandingFooter({ footer, locale, jobsHref }: Props) {
  return (
    <footer className="lp-footer">
      <div className="lp-footer-inner">
        <div className="lp-footer-top">
          <div>
            <a className="lp-footer-logo" href={jobsHref} data-vike="false">
              <img src="/logo.svg" width={20} height={20} alt="JobCrawls" />
              JobCrawls
            </a>
            <p className="lp-footer-tagline">{footer.tagline}</p>
            <div className="lp-footer-lang-pills">
              <a className="lp-footer-lang-pill" href="/en" data-vike="false">EN</a>
              <a className="lp-footer-lang-pill" href="/fi" data-vike="false">FI</a>
              <a className="lp-footer-lang-pill" href="/sv" data-vike="false">SV</a>
            </div>
          </div>
          {footer.cols.map((col) => (
            <div key={col.title}>
              <div className="lp-footer-col-title">{col.title}</div>
              <ul className="lp-footer-links">
                {col.links.map((link) => (
                  <li key={link.href}>
                    <a href={link.href} data-vike="false">{link.label}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="lp-footer-social">
          <FooterSocialMediaBar variant="dark" />
        </div>
        <div className="lp-footer-bottom">
          <div className="lp-footer-copy">{footer.copy}</div>
          <div className="lp-footer-langs">
            <a href="/en" data-vike="false">English</a>
            <a href="/fi" data-vike="false">Suomi</a>
            <a href="/sv" data-vike="false">Svenska</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
